// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/efb-chart-standard.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/efb-chart-standard/efb-ammd-taxi-role.js';
import g1 from '../lessons/navigation/efb-chart-standard/efb-chart-manipulation.js';
import g2 from '../lessons/navigation/efb-chart-standard/efb-chart-standard.js';
import g3 from '../lessons/navigation/efb-chart-standard/efb-own-ship-position-limit.js';

mount([g0, g1, g2, g3]);
